import { IconProps } from "./iconTypes";

export default function CallCancelIcon(props: IconProps) {
  return (
    <svg viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg' width='1.5em' height='1.5em' {...props}>
      <path
        d='M3.12216 17.759L17.756 3.12509L16.8722 2.24121L9.01782 10.0956C8.53145 9.54595 8.10341 8.94356 7.74342 8.29812L9.24711 6.85458L7.96635 2.5H2.50962L2.50034 3.11558C2.49925 3.18804 2.4987 3.26062 2.4987 3.33333C2.4987 5.91914 3.19206 8.34491 4.40342 10.4328C4.91827 11.3202 5.52664 12.1465 6.21508 12.8983L2.23828 16.8751L3.12216 17.759Z'
        fill='currentColor'
      />
      <path
        d='M9.56589 15.5953C9.04194 15.2913 8.53929 14.9547 8.0607 14.5883L10.8941 11.7549C11.1545 11.9337 11.4236 12.1008 11.7006 12.2553L13.1441 10.7516L17.4987 12.0324V17.5H16.6654C14.0796 17.5 11.6538 16.8066 9.56589 15.5953Z'
        fill='currentColor'
      />
    </svg>
  );
}
